import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LIFESTYLE_IMG = "/api/media/lifestyle-tre-birre.jpeg?v=20260912e";

export const LifestyleBanner = () => {
  return (
    <section className="relative bg-[#0D110D]" data-testid="lifestyle-banner">
      <div className="relative h-[70vh] md:h-[85vh] overflow-hidden">
        <motion.img
          initial={{ scale: 1.12 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
          src={LIFESTYLE_IMG}
          alt="Le tre birre 'Sti Cazzi del Birrificio Vecchio Cinghiale — Bionda, Rossa ed Esotica su un tavolo di legno alla luce calda di un'osteria"
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="lifestyle-image"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D110D] via-[#0D110D]/30 to-[#0D110D]/60" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D110D]/70 via-transparent to-transparent" />

        <div className="relative z-10 h-full max-w-[1600px] mx-auto px-6 lg:px-12 flex flex-col justify-end pb-16 md:pb-24">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-2xl"
          >
            <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-5">
              Tre birre, nessun compromesso
            </p>
            <h2 className="font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#E8E2D2] mb-8">
              La compagnia <span className="italic text-[#D47738]">giusta</span> per ogni serata.
            </h2>
            <Link
              to="/catalogo"
              className="inline-flex items-center gap-3 bg-[#D47738] text-[#0D110D] px-8 md:px-10 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors duration-300"
              data-testid="lifestyle-cta"
            >
              Scopri il catalogo
              <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
